import React from 'react';
import { useSelector } from 'react-redux';
import { heroImageConfig } from '../../common/helpers/sharpie/sharpie';
import { handleImageUrl } from '../../common/helpers/sharpie/imageUrlHelper';
import { HeroImageWrapper } from './HeroImage.style';
import MediaCarousel from '../mediaCarousel/MediaCarousel';
import { WholeState } from '../../store/common/type';

interface HeroImageData {
  url: string;
  title: string;
}
interface HeroImageProps {
  heroImageData: HeroImageData;
  isOnProjectPage?: boolean;
  media?: string[];
}
const HeroImage: React.FC<HeroImageProps> = ({
  heroImageData,
  isOnProjectPage,
  media,
}) => {
  const deviceType = useSelector((state: WholeState) =>
    state.common !== undefined ? state.common.deviceType : 'desktop',
  );
  const isNextGenSupported = useSelector((state: WholeState) =>
    state.common !== undefined ? state.common.isNextGenSupported : false,
  );
  const imageInfo = heroImageConfig[deviceType];
  const sharpieImgUri = handleImageUrl(
    heroImageData.url,
    imageInfo.width,
    imageInfo.height,
    isNextGenSupported,
  );
  return (
    <HeroImageWrapper
      data-test={'hero-image'}
      isOnProjectPage={isOnProjectPage}
    >
      {media?.length > 1 ? (
        <MediaCarousel media={media} />
      ) : (
        <img src={sharpieImgUri} alt={heroImageData.title} />
      )}
    </HeroImageWrapper>
  );
};

export default HeroImage;
